/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Canceled_TitleInputs */

const en_notifications_task_canceled_title = /** @type {(inputs: Notifications_Task_Canceled_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} was canceled`)
};

const pt_br2_notifications_task_canceled_title = /** @type {(inputs: Notifications_Task_Canceled_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} foi cancelada`)
};

/**
* | output |
* | --- |
* | "{task} was canceled" |
*
* @param {Notifications_Task_Canceled_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_canceled_title = /** @type {((inputs: Notifications_Task_Canceled_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Canceled_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_canceled_title(inputs)
	return pt_br2_notifications_task_canceled_title(inputs)
});